import { useContext, useEffect }            from 'react';
import { useNavigate }                      from "react-router-dom";
import { BackOfficeContext, useBackOffice } from '../contexts/BackOfficeContext';
import { findPermission }                   from '../utils/UserPermissionUtils.js';
import { useUser }                          from '../contexts/UserContext.js';


import BackOfficeFilter                     from '../components/Filters/BackOfficeTabFilter';
import BackOfficeGroupFilter                from '../components/Filters/BackOfficeGroupFilter';
import UserGroupsTable                      from '../components/Table/UserGroupsTable';
import PermissionModuleTableContainer       from '../components/Table/PermissionModuleTableContainer';
import UserFormContainer                    from '../components/Form/UserFormContainer';
import UserTableContainer                   from '../components/Table/UserTableContainer';

function BackOfficePage() {

    const { selectedBackOffice }    = useContext(BackOfficeContext);
    const { handerUserModalOpen }   = useBackOffice()
    const navigate = useNavigate();

    const { userData }  = useUser()

    useEffect(() => {
        
        if (!userData?.permissions) return;
    
        const hasPermission = findPermission(userData, "Acesso à Pagina de BackOffice");
        if (!hasPermission) {
          navigate("/home");
        }
    
      }, [userData, navigate]);

    return (
        
        <div className="pg-content">
            
            <UserFormContainer/>
            
            <header>
                
                <h1 className="mb-5">Backoffice</h1>

            </header>
                    
            <section className={`w-full bg-neutro borda-cinza rounded-[7px] p-[1rem] flex min-h-[75px]`} style={selectedBackOffice === 'pages' ? {} : { justifyContent: 'flex-end' }}>
               
                {selectedBackOffice === 'groups' ?
                    <button className="btn bg-azul-profundo-m hover:bg-azul-profundo-e h-10" >Cadastrar Grupo</button>
                    :null
                }

                {selectedBackOffice === 'users' ?
                    <button 
                        className="btn bg-azul-profundo-m hover:bg-azul-profundo-e h-10"
                        onClick={handerUserModalOpen}
                    >Cadastrar Usuário</button>
                    :null
                }
                
                {selectedBackOffice === 'pages' ?
                    <BackOfficeGroupFilter/>
                    :null
                }

            </section>

            <BackOfficeFilter />

            {selectedBackOffice === 'groups' ?
                <UserGroupsTable  />
                :null
            }  

            {selectedBackOffice === 'users' ?
                <UserTableContainer/>
                :null
            }

            {selectedBackOffice === 'pages' ?
                <PermissionModuleTableContainer />
                :null
            }

        </div>
    )
}

export default BackOfficePage;